// Utility function to check user roles
export const getUserRole = (user) => {
  if (!user) return [];

  // Check for roles in different possible locations
  const roles =
    user["https://createwithabi.ca/roles"] ||
    user.roles ||
    user.app_metadata?.roles ||
    user.user_metadata?.roles ||
    [];

  return Array.isArray(roles) ? roles : [roles];
};

export const isDealer = (user) => {
  const roles = getUserRole(user);
  const hasDealerRole = roles.some(
    (role) =>
      role.toLowerCase() === "dealer" || role.toLowerCase() === "dealers",
  );
  return hasDealerRole;
};

export const isAdmin = (user) => {
  const roles = getUserRole(user);
  return roles.some(
    (role) =>
      role.toLowerCase() === "admin" || role.toLowerCase() === "administrator",
  );
};
